import { render, staticRenderFns } from "./SwitchFavorite.vue?vue&type=template&id=0cd64caa&"
import script from "./SwitchFavorite.vue?vue&type=script&lang=js&"
export * from "./SwitchFavorite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports